import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

import CHero from "@/components/CHero.vue";
import CAboutMe from "@/components/CAboutMe.vue";
import CMySkills from "@/components/CMySkills.vue";
import CMyWorks from "@/components/my-works/CMyWorks.vue";
import CContact from "@/components/contact/CContact.vue";
import CServices from "@/components/CServices.vue";
import {isResume} from "@/config/app";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("article", null, [
      _createVNode(CHero),
      _createVNode(CAboutMe),
      _createVNode(CMySkills),
      _createVNode(CMyWorks),
      (!_unref(isResume))
        ? (_openBlock(), _createBlock(CServices, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(CContact)
    ])
  ]))
}
}

})